import { $ } from '@/Engine/state';
import { deleteSelectedModel } from '@/Engine/eventHandlers/libs/deleteSelectedModel';

export const onDeleteHandler = (): void => {
    deleteSelectedModel();
    $.render();
};